import React, { useEffect } from 'react';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';

import UserService from '../../service/UserService';
import loginService from '../../service/login';

import LoadingSpinner from '../loadingSpinner';

const userservice = new UserService();

const Epic = (props) => {
  const history = useHistory();

  useEffect(() => {
    epicAuth();
  }, []);

  const epicAuth = async () => {
    const parsed = queryString.parse(props.location.search);
    const paths = props.location.pathname.split('/');
    const practiceId = paths[2];
    if (practiceId) {
      loginService.setPracticeId(practiceId);
    }
    try {
      const urlData = await userservice.loginWithEhr(
        'epic',
        parsed.launch,
        practiceId
      );
      window.location.href = urlData.url;
    } catch (e) {
      history.push('/login');
    }
  };

  return <LoadingSpinner title="Loading" type="text" />;
};

export default Epic;
